import {Component, OnDestroy, OnInit} from '@angular/core';
import {SettingsService} from "../../../services/settings.service";
import {BehaviorSubject, Subscription} from "rxjs";
import {SupportService} from "../../../services/support.service";
import {NzModalService} from "ng-zorro-antd/modal";
import {ConfirmationModalComponent} from "../dialogs/confirmation-modal/confirmation-modal.component";
import {ApiService} from "../../../services/api.service";

@Component({
  selector: 'app-welcome-widget',
  templateUrl: './welcome-widget.component.html',
  styleUrls: ['./welcome-widget.component.scss']
})
export class WelcomeWidgetComponent implements OnInit, OnDestroy {

  onBoardingSubscription: Subscription;
  moreOptions = [
    {
      "icon": "assets/media/icons/custom/book.svg",
      "title" : "Knowledge Base",
      "subtitle" : "Comprehensive Guides",
      "action": "external",
      "url": ""
    },
    {
      "icon": "assets/media/icons/custom/video.svg",
      "title" : "Video Learning",
      "subtitle" : "Easy to follow",
      "action": "external",
      "url": ""
    },
    {
      "icon": "assets/media/icons/custom/conversation.svg",
      "title" : "Get Support",
      "subtitle" : "Ask us for help",
      "action": "internal",
      "url": ""
    }
  ]

  constructor(public support: SupportService, public settings: SettingsService, private modal: NzModalService, private api:ApiService) { }

  ngOnInit(): void {

    this.api.getSettings().then((res)=>{
      this.settings.settings = res;
    });

  }

  ngOnDestroy() {
  }

  dismissDialog(){

    this.modal.create({
      nzContent: ConfirmationModalComponent,
      nzOnOk: () => {
        const settings = this.settings.settings;
        settings.Onboarding.Complete = true;
        this.settings.settings = settings;
      },
      nzComponentParams: {
        confirmationMessage: 'Are you sure you want to dismiss this? You can return to this by visiting the top right menu at any time.',
        actionURL: '/settings/dismissOnboard',
        actionMethod: 'Post',
        submitButton: 'Yes I\'m sure'
      }
    })

  }

  stepsComplete(){

    return !!(this.settings.settings.Onboarding.BrandComplete &&
      this.settings.settings.Onboarding.AnalyzeComplete &&
      this.settings.settings.Onboarding.EmailSetup &&
      this.settings.settings.Onboarding.CampaignComplete);

  }

  showAnalyzeVideo(){



  }

}
